import API_URL from "../config";
import axios from "axios";
import { getCookie } from "./../utils/cookies";

export const addNewRevendeurApi = async (revendeurData) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const objectData = {
      eventID: revendeurData?.eventID ?? null,
      firstName: revendeurData?.firstName ?? "",
      lastName: revendeurData?.lastName ?? "",
      email: revendeurData?.email ?? "",
      phone: revendeurData?.phone ?? "",
      pseudo: revendeurData?.pseudo ?? "",
      password: revendeurData?.password ?? "",
      confirmPass: revendeurData?.confirmPass ?? "",
      fromProduced: revendeurData?.fromProduced ?? null,
    };

    let url = `${API_URL}/api/V2/revendeur/signup/${id}/${iv}`;

    const res = await axios.post(url, objectData, option);

    return res.data;
  } catch (err) {
    console.error("API Error adding new revendeur:", err.response?.data?.error || err.message);
    throw err;
  }
};

export const signInRevendeur = async (email, password) => {
  try {
    const userObject = {
      email: email,
      password: password,
    };

    const res = await axios.post(`${API_URL}/api/V2/revendeur/signIn`, userObject);

    return res.data;
  } catch (err) {
    console.error("Revendeur sign-in API error:", err.response?.data?.error || err.message);
    throw err;
  }
};
